<template>
  <div class="documents-module-page">
    <header class="page-title">
      <p class="page-kicker">Tutoriales de Documentos</p>
      <!-- <h1>Modulo de Documentos</h1> -->
    </header>

    <section class="video-wrapper" aria-label="Video de modulo de documentos">
      <div class="video-frame">
        <iframe
          :src="embedVideoUrl"
          title="Video del modulo de documentos"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowfullscreen
        />
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "TutorialsDocuments",
  data() {
    return {
      embedVideoUrl: "https://www.youtube.com/embed/AnF-NkX-3aU"
    };
  }
};
</script>

<style scoped>
.documents-module-page {
  min-height: calc(100vh - 96px);
  padding: 24px;
}

.page-title {
  max-width: 1180px;
  margin: 0 auto 20px;
  padding: 0 8px;
}

.page-kicker {
  margin: 0 0 8px;
  color: #64748b;
  font-size: 1.12rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.page-title h1 {
  margin: 0;
  color: #0f172a;
  font-size: clamp(1.9rem, 3vw, 3rem);
  line-height: 1.1;
}

.video-wrapper {
  max-width: 1180px;
  margin: 0 auto;
}

.video-frame {
  position: relative;
  overflow: hidden;
  border-radius: 0;
  aspect-ratio: 16 / 9;
}

.video-frame iframe {
  width: 100%;
  height: 100%;
  border: 0;
}

@media (max-width: 768px) {
  .documents-module-page {
    padding: 16px;
  }

  .page-header {
    padding: 22px 20px;
  }
}
</style>
